import axios from "axios";

const http = axios.create({
  baseURL: "https://www.carenessland.com/config/",
  // baseURL: "http://localhost:4122/web/api/",
});

export default http;
